import { render, staticRenderFns } from "./TTWarehouseBatch.vue?vue&type=template&id=97257d28&scoped=true"
import script from "./TTWarehouseBatch.vue?vue&type=script&lang=js"
export * from "./TTWarehouseBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97257d28",
  null
  
)

export default component.exports